import { z } from 'zod';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export const contentQuestionsEndpoints = {
  postQuestions: {
    path: 'question-generator/v1/questions',
    schema: z.object({
      questions: z.array(z.string()),
    }),
  },
};

export type PostContentQuestionsResponse = z.infer<
  typeof contentQuestionsEndpoints.postQuestions.schema
>;

export const postContentQuestions = (content: string, signal?: AbortSignal) =>
  wretchRequest<PostContentQuestionsResponse>(
    contentQuestionsEndpoints.postQuestions.path,
    {
      method: 'post',
      schema: contentQuestionsEndpoints.postQuestions.schema,
      body: { content },
      signal,
    }
  );
